import {AbstractEvent} from "@/modules/base/events";
import {TransferListing, TransferOffer} from "@/modules/transfer-market/entity";
import {Player} from "@/modules/team/entity";

export class AfterTransferOfferCreateEvent extends AbstractEvent {
  constructor(
    public player: Player,
    public offer: TransferOffer,
    public listing?: TransferListing,
  ) {
    super();
  }
}